export var PAGINATED_COMPONENT = {
    tags: [],
};
